<template>
  <div class="timepicker">
    <input type="text" class="inp_time" :value="timeText" readonly>
    <div v-if="buttonContainerView" class="timepicker_container">
      <ul class="timepicker_list">
        <li class="cell" v-for="(date, index) in dateList" :key="index">
          <button type="button" class="time" :class="{disabled: date.disabled, selected: date.selected}" @click="onClickTime(date)">{{date.timeText}}</button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import toggleContainer from '$mixins/toggleContainer'

export default {
  mixins: [ toggleContainer ],
  props: {
    value: {
      type: [ Date, Number, String ],
      default() {
        return new Date()
      }
    },
    minDate: {
      type: [ Date, Number, String ],
      default() {
        const date = new Date()
        date.setFullYear(date.getFullYear() - 10)
        return date
      }
    },
    maxDate: {
      type: [ Date, Number, String ],
      default() {
        const date = new Date()
        date.setFullYear(date.getFullYear() + 10)
        return date
      }
    },
    displayTime: {
      type: String,
      default: '00:00~23:59'
    },
    defaultTime: {
      type: String
    },
    timeUnit: {
      type:Number,
      default: 30
    }
  },
  data() {
    return {
      selectedDate: null
    }
  },
  watch: {
    value() {
      this.setSelectedDate()
    }
  },
  computed: {
    timeText() {
      return this.$utils.dateformat(this.selectedDate, 'HH:MM')
    },
    startHour() {
      return parseInt(this.displayTime.split('~')[0].split(':')[0], 10)
    },
    startMin() {
      return parseInt(this.displayTime.split('~')[0].split(':')[1], 10)
    },
    endHour() {
      return parseInt(this.displayTime.split('~')[1].split(':')[0], 10)
    },
    endMin() {
      return parseInt(this.displayTime.split('~')[1].split(':')[1], 10)
    },
    defaultTimeForOverTime() {
      return this.defaultTime || `${this.startHour}:${this.startMin}`
    },
    dateList() {
      const result = []
      const loopDate = new Date(this.selectedDate)
      loopDate.setHours(this.startHour, this.startMin, 0, 0)

      const endDate = new Date(loopDate)
      endDate.setHours(this.endHour, this.endMin, 0, 0)

      while(loopDate <= endDate) {
        let date = new Date(loopDate)
        date.disabled = date < this.minDate || date > this.maxDate
        date.selected = date.getTime() === this.selectedDate.getTime()
        date.timeText = this.$utils.dateformat(date, 'HH:MM')
        result.push(date)
        loopDate.setMinutes(loopDate.getMinutes() + this.timeUnit)
      }
      return result
    }
  },
  methods: {
    setSelectedDate() {
      const selectedDate = new Date(this.value)
      let min = selectedDate.getMinutes(), hour
      if (min % this.timeUnit) min += this.timeUnit - min % this.timeUnit
      selectedDate.setMinutes(min, 0, 0)

      hour = selectedDate.getHours()
      min = selectedDate.getMinutes()
      const overStart = hour < this.startHour || (hour === this.startHour && min < this.startMin)
      const overEnd = hour > this.endHour || (hour === this.endHour && min > this.endMin)
      if (overStart || overEnd) {
        const ot = this.defaultTimeForOverTime.split(':')
        selectedDate.setHours(parseInt(ot[0], 10), parseInt(ot[1], 10), 0, 0)
      }

      this.selectedDate = selectedDate
    },
    onClickTime(date) {
      this.toggleButtonContainer(false)
      this.selectedDate = date
      this.$emit('change', date)
    },
    getTime() {
      return this.timeText
    },
    getDate() {
      return new Date(this.selectedDate)
    }
  },
  mounted() {
    this.setSelectedDate()
  }
}

// (시간, 분, 초, 밀리초)를 0으로 설정한 새로운 객체 반환
function toZeroTimes(date) {
  const result = new Date(date)
  result.setHours(0, 0, 0, 0)
  return result
}

</script>

<style scoped>
.disabled {
  opacity: 0.3;
  pointer-events: none;
}
.selected {
  background: #338ffc;
  color: #fff;
}
</style>
